<nav class="navbar bolder navbar-expand-lg p-lg-0" role="navigation" [ngClass]="displayMode === 'vertical' ? 'navbar-vertical' : ''">
    <div class="container justify-content-start">

        <button class="navbar-toggler m-1 mr-3 p-0" type="button" aria-label="Toggle navigation" (click)="toggleSideMenu()" *ngIf="displayMode === 'horizontal'">
            <i class="fa fa-bars" aria-hidden="true"></i>
        </button>

        <div class="navbar-brand nav-logo">
            <a class="nav-logo-link" routerLink="/">
                <app-logo></app-logo>
            </a>
        </div>

        <div class="navbar-collapse" [ngClass]="displayMode === 'horizontal' ? 'collapse' : ''">

            <!-- navigation links -->
          <ul class="navbar-nav" [ngClass]="displayMode === 'horizontal' ? 'navbar-horizontal' : ''" *ngIf="routeLinks$ | async as routeLinks">

            <ng-container *ngIf="false">
              <!--ONLY USED TO GENERATE TRANSLATEABLE STRINGS THAT WE CAN FETCH AND USE IN ROUTE CONFIG-->
              <li i18n="topnav topnav@@topnav-topnav">Today</li>
              <li i18n="topnav your board@@topnav-your-board">Your board</li>
              <li i18n="topnav collaboration@@topnav-collaboration">Collaboration</li>
              <li i18n="topnav menu@@topnav-menu">Find information</li>
              <li i18n="find colleague topnav menu@@topnav-find-colleague">Find colleague</li>
            </ng-container>

            <li class="nav-item" *ngFor="let route of routeLinks" routerLinkActive="active" [routerLinkActiveOptions]="{exact:route.data.exact}" #routeLink="routerLinkActive">
              <h1 class="sr-only">{{route.data.title}}</h1>
              <a class="nav-link"
                 [attr.aria-label]="route.data.title"
                 [routerLink]="route.path"
                 [matBadgeHidden]="(route.showBadge$ | async) === false"
                 matBadgeOverlap="true"
                 matBadgeSize="small"
                 matBadge="&zwnj;"
                 matBadgePosition="above after">
                <span *ngIf="route.data.prefix" class="mr-1">{{workplaceName}}</span>
                <span>{{route.data.title}}</span>
              </a>

            </li>

            <li *ngIf="guideUrl" class="nav-item" routerLinkActive="active" #routeLink="routerLinkActive">
              <h1 class="sr-only">Guide</h1>
              <a class="nav-link"
                 [attr.aria-label]="Guide"
                 [attr.href]="guideUrl">
                <span i18n="guide link@@guide-link">Guide</span>
              </a>
            </li>

            <li *ngIf="additionalTopNavLink" class="nav-item">
              <h1 class="sr-only">{{additionalTopNavLink.title}}</h1>
              <a class="nav-link"
                 [attr.aria-label]="titleTopNav"
                 [attr.href]="additionalTopNavLink.url" target="additionalTopNavLink.target">
                <span>{{additionalTopNavLink.title}}</span>
              </a>
            </li>
          </ul>

        </div>

        <div class="ml-auto" *ngIf="displayMode === 'horizontal'">
            <!--ONLY USED TO PUSH CONTENT TO LEFT AND RIGHT-->
        </div>

        <ng-container *appFeatureToggle="'showSearchbarInTopNav'">
            <div *ngIf="displayMode === 'horizontal'">
                <app-search-form></app-search-form>
            </div>
        </ng-container>

        <ng-container *appFeatureToggle="'showBroadcastsIconInTopNav'">
            <div class="ml-3" *ngIf="displayMode === 'horizontal'">
                <app-topnav-broadcasts></app-topnav-broadcasts>
            </div>
        </ng-container>

        <div class="ml-3" *ngIf="displayMode === 'horizontal'">
            <app-user-menu></app-user-menu>
        </div>

    </div>
</nav>
